import dayjs from "dayjs";
import { useEffect, useState } from "react";
import useStore from "../store/store";
import { IAllocation } from "../types/allocation";
import { IEventDateType } from "../types/eventDate";
import dateToLocaleString from "../utils/dateToLocaleString";
import {
  InformationCircleIcon,
  MailIcon,
  PhoneIcon,
  CheckCircleIcon,
  EyeOffIcon,
  EyeIcon,
} from "@heroicons/react/outline";
const TimesheetEventDate = () => {
  const {
    activeEvent,
    eventDates,
    allocations,
    shifts,
    worktimes,
    updateWorktime,
    addWorktime,
    setTimeSheetCheck,
    updateWorktimeNote,
  } = useStore();

  const [dates, setDates] = useState<IEventDateType[]>([]);
  const [notSentAllocations, setNotSentAllocations] = useState<IAllocation[]>(
    []
  );

  useEffect(() => {
    // load the allocations that are not sent to the backoffice yet
    const notSentAllocations = allocations.filter(
      (alloc) =>
        alloc.status === "available" &&
        new Date(alloc.date).setHours(0, 0, 0, 0) <
          new Date().setHours(0, 0, 0, 0)
    );

    // set the not sent allocations
    setNotSentAllocations(notSentAllocations);

    // get the dates of these allocations
    setDates(
      eventDates.filter((ed) =>
        notSentAllocations.some((nsa) => nsa["dateId"] === ed._id)
      )
    );
  }, [allocations, eventDates]);

  return (
    <div className="container mx-auto mt-4 text-xs">
      {!!eventDates.filter((ed) => ed.eventId === activeEvent?._id).length && (
        <div className="flex justify-between w-full">
          <div className="px-5 flex w-full">
            <div className="flex-1">Shift</div>
            <div className="flex-1">Medewerker</div>
            <div className="flex-1">Start</div>
            <div className="flex-1">Einde</div>
            <div className="flex-1">
              Pauze <br /> start
            </div>
            <div className="flex-1">
              Pauze <br /> einde
            </div>
            <div className="flex-1">Start</div>
            <div className="flex-1">Einde</div>
            <div className="flex-1">
              Pauze <br /> start
            </div>
            <div className="flex-1">
              Pauze <br /> einde
            </div>
            <div className="w-60 text-center">Opmerking</div>
          </div>
        </div>
      )}

      {dates
        .filter((d) => d.eventId === activeEvent?._id)
        .sort((a, b) => (a.eventDate < b.eventDate ? -1 : 1))
        .map((date) => {
          return (
            <div key={date._id}>
              <div className="flex items-center justify-between font-bold bg-light-blue h-[50px] px-5">
                <p className="text-base">
                  {dateToLocaleString(date.eventDate)}
                </p>
                <button
                  onClick={() =>
                    setTimeSheetCheck(date._id, !date.timeSheetCheck)
                  }
                >
                  {date.timeSheetCheck ? (
                    <EyeIcon color="grey" height={20}></EyeIcon>
                  ) : (
                    <EyeOffIcon color="grey" height={20} />
                  )}
                </button>
              </div>

              {notSentAllocations
                .filter((nsa) => nsa.dateId === date._id)
                .map((allocation) => {
                  const worktime = worktimes.find(
                    (worktime) => worktime.allocationId === allocation._id
                  );

                  const clockShiftStart = worktimes.find(
                    (worktime) => worktime.allocationId === allocation._id
                  )?.shiftStart;

                  const clockShiftEnd = worktimes.find(
                    (worktime) => worktime.allocationId === allocation._id
                  )?.shiftEnd;

                  const clockPauseStart = worktimes.find(
                    (worktime) => worktime.allocationId === allocation._id
                  )?.pauseStart;

                  const clockPauseEnd = worktimes.find(
                    (worktime) => worktime.allocationId === allocation._id
                  )?.pauseEnd;

                  const note = worktimes.find(
                    (worktime) => worktime.allocationId === allocation._id
                  )?.note;

                  return (
                    <div
                      className="flex justify-between items-center py-5 hover:bg-background-grey w-full"
                      key={allocation._id}
                    >
                      <div className="px-5 w-full flex">
                        <div className="flex-1">
                          {
                            shifts.find(
                              (shift) => shift._id === allocation.shiftId
                            )?.shiftName
                          }
                        </div>
                        <div className="flex-1">{`${allocation.employeeFirstName} ${allocation.employeeLastName}`}</div>
                        <div className="flex-1">
                          {
                            shifts.find(
                              (shift) => shift._id === allocation.shiftId
                            )?.shiftStart
                          }
                        </div>
                        <div className="flex-1">
                          {
                            shifts.find(
                              (shift) => shift._id === allocation.shiftId
                            )?.shiftEnd
                          }
                        </div>
                        <div className="flex-1">
                          {shifts.find(
                            (shift) => shift._id === allocation.shiftId
                          )?.breakStart === ""
                            ? "(geen)"
                            : shifts.find(
                                (shift) => shift._id === allocation.shiftId
                              )?.breakStart}
                        </div>
                        <div className="flex-1">
                          {shifts.find(
                            (shift) => shift._id === allocation.shiftId
                          )?.breakEnd === ""
                            ? "(geen)"
                            : shifts.find(
                                (shift) => shift._id === allocation.shiftId
                              )?.breakEnd}
                        </div>
                        <div className="flex-1">
                          <input
                            className="border-b-2 border-0 border-light-gray w-16 text-xs p-0 text-center bg-transparent"
                            type="time"
                            name="shiftStart"
                            id="shiftStart"
                            disabled={allocation.sentToBackOffice}
                            value={
                              clockShiftStart === undefined ||
                              clockShiftStart === "" ||
                              isNaN(parseInt(clockShiftStart))
                                ? shifts.find(
                                    (shift) => shift._id === allocation.shiftId
                                  )?.shiftStart
                                : dayjs(
                                    new Date(
                                      parseInt(clockShiftStart)
                                    ).toISOString()
                                  ).format("HH:mm")
                            }
                            onChange={(e) => {
                              if (worktime !== undefined) {
                                updateWorktime({
                                  ...worktime,
                                  shiftStart: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                });
                              } else {
                                addWorktime({
                                  _id: null,
                                  shiftStart: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                  shiftEnd: "",
                                  pauseStart: "",
                                  pauseEnd: "",
                                  employeeId: allocation.employeeId,
                                  allocationId:
                                    allocation._id === undefined
                                      ? ""
                                      : allocation._id,
                                  note: "",
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex-1">
                          <input
                            className="border-b-2 border-0 border-light-gray w-16 text-xs p-0 text-center bg-transparent"
                            type="time"
                            name="shiftEnd"
                            id="shiftEnd"
                            disabled={allocation.sentToBackOffice}
                            value={
                              clockShiftEnd === undefined ||
                              clockShiftEnd === "" ||
                              isNaN(parseInt(clockShiftEnd))
                                ? shifts.find(
                                    (shift) => shift._id === allocation.shiftId
                                  )?.shiftEnd
                                : dayjs(
                                    new Date(
                                      parseInt(clockShiftEnd)
                                    ).toISOString()
                                  ).format("HH:mm")
                            }
                            onChange={(e) => {
                              if (worktime !== undefined) {
                                updateWorktime({
                                  ...worktime,
                                  shiftEnd: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                });
                              } else {
                                addWorktime({
                                  _id: null,
                                  shiftStart: "",
                                  shiftEnd: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                  pauseStart: "",
                                  pauseEnd: "",
                                  employeeId: allocation.employeeId,
                                  allocationId:
                                    allocation._id === undefined
                                      ? ""
                                      : allocation._id,
                                  note: "",
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex-1">
                          <input
                            className="border-b-2 border-0 border-light-gray w-16 text-xs p-0 text-center bg-transparent"
                            type="time"
                            name="breakStart"
                            id="breakStart"
                            disabled={allocation.sentToBackOffice}
                            value={
                              clockPauseStart === undefined ||
                              clockPauseStart === "" ||
                              isNaN(parseInt(clockPauseStart))
                                ? shifts.find(
                                    (shift) => shift._id === allocation.shiftId
                                  )?.breakStart
                                : dayjs(
                                    new Date(
                                      parseInt(clockPauseStart)
                                    ).toISOString()
                                  ).format("HH:mm")
                            }
                            onChange={(e) => {
                              if (worktime !== undefined) {
                                updateWorktime({
                                  ...worktime,
                                  pauseStart: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                });
                              } else {
                                addWorktime({
                                  _id: null,
                                  shiftStart: "",
                                  shiftEnd: "",
                                  pauseStart: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                  pauseEnd: "",
                                  employeeId: allocation.employeeId,
                                  allocationId:
                                    allocation._id === undefined
                                      ? ""
                                      : allocation._id,
                                  note: "",
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex-1">
                          <input
                            className="border-b-2 border-0 border-light-gray w-16 text-xs p-0 text-center bg-transparent"
                            type="time"
                            name="breakEnd"
                            id="breakEnd"
                            disabled={allocation.sentToBackOffice}
                            value={
                              clockPauseEnd === undefined ||
                              clockPauseEnd === "" ||
                              isNaN(parseInt(clockPauseEnd))
                                ? shifts.find(
                                    (shift) => shift._id === allocation.shiftId
                                  )?.breakEnd
                                : dayjs(
                                    new Date(
                                      parseInt(clockPauseEnd)
                                    ).toISOString()
                                  ).format("HH:mm")
                            }
                            onChange={(e) => {
                              if (worktime !== undefined) {
                                updateWorktime({
                                  ...worktime,
                                  pauseEnd: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                });
                              } else {
                                addWorktime({
                                  _id: null,
                                  shiftStart: "",
                                  shiftEnd: "",
                                  pauseStart: "",
                                  pauseEnd: (+new Date(
                                    `${date.eventDate}T${e.target.value}:00`
                                  )).toString(),
                                  employeeId: allocation.employeeId,
                                  allocationId:
                                    allocation._id === undefined
                                      ? ""
                                      : allocation._id,
                                  note: "",
                                });
                              }
                            }}
                          />
                        </div>
                        <div className="flex-1">
                          <input
                            className="border-b-2 border-0 border-light-gray w-60 text-xs p-0 bg-transparent h-[20.6px]"
                            type="text"
                            name="note"
                            id="note"
                            disabled={allocation.sentToBackOffice}
                            value={note}
                            onFocus={(e) => {
                              if (worktime === undefined) {
                                addWorktime({
                                  _id: null,
                                  shiftStart: "",
                                  shiftEnd: "",
                                  pauseStart: "",
                                  pauseEnd: "",
                                  employeeId: allocation.employeeId,
                                  allocationId:
                                    allocation._id === undefined
                                      ? ""
                                      : allocation._id,
                                  note: "",
                                });
                              }
                            }}
                            onChange={(e) => {
                              if (
                                worktime === undefined ||
                                worktime._id === null
                              )
                                return;
                              updateWorktimeNote(e.target.value, worktime?._id);
                            }}
                            onBlur={(e) => {
                              if (
                                worktime === undefined ||
                                worktime._id === null
                              )
                                return;
                              updateWorktime({
                                ...worktime,
                                note: e.target.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          );
        })}
    </div>
  );
};

export default TimesheetEventDate;
